import React from 'react';
import Button from "../Utilities/CustomButton";

const Input = ({ className='', label='', type = 'text', value, onChange,onDownload, onView, options, ...props }) => {

  // ---------------------------
  const handleChange = (e) => {
    if (typeof onChange === 'function') {
      onChange(e.target.value);
    }
  }
  const handleDownload = (item) => {
    if (typeof onDownload === 'function') {
      onDownload(item);
    }
  }

  const handleView = (item) => {
    if (typeof onView === 'function') {
      onView(item);
    }
  }


  // ---------------------------
  const handleCheckboxClick = (option) => {
    const newValue = value || [];
    // console.log(newValue, option, newValue.includes(option))
    if (newValue.includes(option)) {
      onChange(newValue.filter((v) => v !== option));
    } else {
      onChange([...newValue, option]);
    }
  }

  // ---------------------------
  const renderInput = () => {
    switch (type) {
      case null:
        return null;
      case 'select':
        return (
          <select className="form-input__select" value={value}>
          {(options || []).map((option) => (
            <option key={option.key} value={option.value}>{option.label}</option>
          ))}
          </select>
        )
      case 'upload':
        return (
          <>
          <p className="form-input__description">{props.description}</p>
          <div className="form-input__file">
            <div className="input-file-custom">
              <input className="input-file-custom__input" type="file" value={value} onChange={handleChange} {...props} />
              <Button outline={true} className="input-file-custom__button">
                <i className="icon-upload"></i> Téléverser un fichier
              </Button>
            </div>
          </div>
          </>
        );
      case 'multiselect-files':
        return (
          <div className="form-input__multiselect">
            <ul className="file-item-select">
              {(options || []).map((option) => (
                <li key={option.value} className="file-item-option">
                  <input type="checkbox" className="file-item-option__input" onChange={() => handleCheckboxClick(option.value)} checked={(value || []).includes(option.value)} />
                  <span className="file-item-option__icon">
                    <i className={`${option.icon}`}></i>
                  </span>
                  <span className="file-item-option__label">{option.label}</span>
                  <span className="file-item-option__preview" onClick={() => {handleView(option)}}>
                    <i className="icon-view"></i>  
                  </span>
                  <span className="file-item-option__download" onClick={() => {handleDownload(option)}}>
                    <i className="icon-download"></i>  
                  </span>
                </li>
              ))}
            </ul>
          </div>
        );
      case 'textarea':
        return (<textarea className="form-input__input" value={value} onChange={handleChange} {...props} />);
      default:
        return (<input className="form-input__input" type={type} value={value} onChange={handleChange} {...props} />)
    }
  }

  // ---------------------------
  return (<div className={`form-input form-input--${type} ${props.id ? 'form-input--'+props.id : ''} ${className}`}>
    {label !== '' && <label className="form-input__label">{label}</label>}
    {renderInput()}
  </div>);
}

export default Input;